import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ImageTextCtaList",
    component: () =>
        __SERVER__ ? require("./image-text-cta-list-view") : import("./image-text-cta-list-view")
});

export default definition;
